import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from './navigation.service';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorNavigationService {
  private navigationService: NavigationService | undefined;

  constructor(
    private readonly router: Router,
    private readonly injector: Injector,
    private readonly loadingService: LoadingService
  ) {}

  navigateToErrorPage(errorCode: string): void {
    this.navigationService ??= this.injector.get(NavigationService);

    if (errorCode >= '500') {
      this.loadingService.setLoading(false);
      window.location.href = '/500';
    }
  }
}
